module.exports = __webpack_public_path__ + "static/media/map.197c59c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/map.png
// module id = 12
// module chunks = 0